import { useCallback } from 'react';
import { useCollaborationSession } from 'copilot-toolkit/hooks/useCollaborationSession';
import PortalIdParser from 'PortalIdParser';
import { hatchActionEggs } from 'automation-ui-canvas/utils/aiAssistantUtils';
const useCollabGenerateActions = ({
  onPreview,
  onApply,
  flowId,
  sessionId
}) => {
  const portalId = PortalIdParser.get();
  const handleCopilotAction = useCallback(data => {
    const {
      toolOutput,
      messageQuery
    } = data.payload.infoToPassToApp;
    switch (data.payload.actionType) {
      case 'apply_actions':
        onApply({
          toolOutput: {
            firstActionId: toolOutput === null || toolOutput === void 0 ? void 0 : toolOutput.firstActionId,
            actions: hatchActionEggs({
              flowId,
              portalId,
              actionEggs: toolOutput === null || toolOutput === void 0 ? void 0 : toolOutput.actionEggs
            })
          },
          messageQuery
        });
        break;
      case 'preview_actions':
        {
          onPreview({
            toolOutput: {
              firstActionId: toolOutput === null || toolOutput === void 0 ? void 0 : toolOutput.firstActionId,
              actions: hatchActionEggs({
                flowId,
                portalId,
                actionEggs: toolOutput === null || toolOutput === void 0 ? void 0 : toolOutput.actionEggs
              })
            },
            messageQuery
          });
          break;
        }
      default:
        break;
    }
  }, [onApply, onPreview, flowId, portalId]);
  const {
    sendActionFromAppToCopilot,
    isCopilotReady
  } = useCollaborationSession({
    onCopilotAction: handleCopilotAction,
    onGetCurrentSessionContext: () => {},
    sessionId,
    appName: 'workflows',
    plugin: 'WorkflowsGenerateActionsPlugin'
  });
  return {
    sendActionFromAppToCopilot,
    isCopilotReady
  };
};
export default useCollabGenerateActions;